import { Injectable } from '@angular/core';
import PhoneNumber from "awesome-phonenumber";
import { isEmpty } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class FormatHelperService {

  firstDateFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDate();
    return day === 1;
  };

  endDateFilter = (d: Date | null): boolean => {
    const day = d || new Date();
    const lastDay = new Date(day.getFullYear(), day.getMonth() + 1, 0).getDate();
    return day.getDate() === lastDay;
  };

  removeCurrency(value?: string) {
    return parseFloat((value?.toString() || '0').replace(/[^.0-9]/g, ''));
  }

  formatCurrency(value?: string | number): string {
    let newVal = value?.toString() || '';
    newVal = newVal.replace(/[^.0-9]/g, '');

    if (newVal !== '') {
      newVal = Number(parseFloat(newVal).toFixed(2)).toLocaleString('en', {
        minimumFractionDigits: 2,
      });
      return `$${newVal}`;
    } else {
      return '';
    }
  }

  formatMinMaxValuation(prices: any[], includeAsterisk: boolean = false): string {
    let valuation = '$0';
    if (prices) {
      const minValue = Math.min(...prices);
      const maxValue = Math.max(...prices);
      valuation = this.formatCurrencyLocal(minValue);
      if (minValue !== maxValue) {
        valuation += ' - ' + this.formatCurrencyLocal(maxValue) + (includeAsterisk ? '*' : '');
      }
    }
    return valuation;
  }

  formatCurrencyLocal(value: number) {
    if (value === null) {
      value = 0;
    }
    return value.toLocaleString('us-EN', {
      style: 'currency',
      currency: 'USD',
    });
  }

  formatDigits(value: number, maximumFractionDigits: number = 4) {
    if (value === null) {
      value = 0;
    }
    return value.toLocaleString(undefined, {
      maximumFractionDigits: maximumFractionDigits,
    });
  }

  formatPhone($event: any, formControl: any) {
    const value = $event?.target.value;
    let isValid = true;
    if (!isEmpty(value)) {
      const pn = new PhoneNumber(value, 'US');
      isValid = !pn.isValid();
      formControl.setValue(
        isValid ? value : pn.getNumber('e164')
      );
    }
    formControl.setErrors(
      isValid ? { invalid: true } : null
    );
    return isValid;
  }

  isUUID(str: any) {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(str);
  }

  monthsBetween(dateA, dateB) {
    let totalMonths = 0;

    // 1. Fraction of the starting month
    const daysInStartMonth = new Date(dateA.getFullYear(), dateA.getMonth() + 1, 0).getDate();
    const daysElapsedStart = daysInStartMonth - dateA.getDate() + 1;
    totalMonths += daysElapsedStart / daysInStartMonth;

    // 2. Whole months in between
    let fullMonths = (dateB.getFullYear() - dateA.getFullYear()) * 12 +
      (dateB.getMonth() - dateA.getMonth()) - 1;
    if (fullMonths > 0) {
      totalMonths += fullMonths;
    }

    // 3. Fraction of the ending month
    const daysInEndMonth = new Date(dateB.getFullYear(), dateB.getMonth() + 1, 0).getDate();
    const daysElapsedEnd = dateB.getDate();
    totalMonths += daysElapsedEnd / daysInEndMonth;

    return totalMonths;
  }
}
